export enum SettingId {
    TH = '1'
    , MY = '2'
    , SG = '3'
    , VN = '4'
    , HK = '5'
    , THCG = '1006'
    , TW = '1007'
}


// WEBPACK FOOTER //
// ./src/enums/settingid.enum.ts